import React, { useContext } from "react";
import { GoCheckCircle } from "react-icons/go";
import CartContext from "../../context/CartContext";
import { StoreContext } from "../../context/StoreContext";
import UserContext from "../../context/UserContext";
import Vector from "../../assets/Vector 112.png";
import Confetty from "../../assets/confetty 1.png";
import SmallVector from "../../assets/Vector.png";

const OrderSuccessPopup = ({onClose}) => {
  const cartCtx = useContext(CartContext);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const userCtx = useContext(UserContext);

 const handlePrint = () => {
  // Open print dialog
  window.print();
};


  return (
    <div className="success-popup">
      <div style={{
        position: 'fixed',
        top: '24px',
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: '"Sora" sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          position: 'absolute',
          top: '80px',
          left: '20px',
          fontSize: '24px',
          color: 'white'
        }}>
          <span style={{ fontSize: '30px' }}><img src={SmallVector}/></span>
        </div>
        <div style={{
          position: 'absolute',
          top: '80px',
          right: '20px',
          fontSize: '24px',
          color: 'white'
        }}>
          <span style={{ fontSize: '30px' }}><img src={SmallVector}/></span>
        </div>

        <div className="confetti" style={{
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '-webkit-fill-available',
          width: '100%',
          marginBottom: '170px',
          height:'100%',
          borderRadius: '0px 10px 0px 10px',
        }}>
          <img src={Confetty} alt="Confetti popper" style={{ width: '150px', marginBottom: '20px' }} />
          <div className="sucess-msg">
            <div className="order-wor" style={{
              fontSize: '28px',
              fontWeight: '500',
              marginBottom: '18px',
              color: '#000000',
              textAlign: 'center'
            }}>
              <span>Order Placed</span>
            </div>
            <div className="succe-wor" style={{
              fontSize: '37px',
              fontWeight: '500',
              margin: 0,
              color: '#000000',
              textAlign: 'center'
            }}>
              <span>Successfully</span>
            </div>
            <div style={{
              fontSize: '15px',
              fontWeight: '500',
              color: '#696969',
              textAlign: 'center',
              marginTop:'20px'
            }}>
              <span>Your Order Id: </span>
            </div>
          </div>
          <button
            onClick={handlePrint}
            style={{
              padding: '12px 62px',
              border: 'none',
              borderRadius: '25px',
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white',
              background: 'linear-gradient(90deg, #ff5722, #ff8c00)',
              cursor: 'pointer',
              marginTop: '20px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              cursor:'pointer',
              zIndex:'100'
            }}
          >
           Print
          </button>
        </div>
        <img src={Vector} alt="Firecrackers" style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          maxWidth: '600px',
          height: '250px',
          zIndex: 2
        }} />
      </div>
    </div>
  );
};

export default OrderSuccessPopup;
